import styled from "styled-components";
import { tablet } from '@shared/ui/atoms/MediaQueries';

export const OfficeUsageContentWrapper = styled.div`
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 16px;
  @media (${tablet}) {
    padding: 0;
  }
`
